import { render, staticRenderFns } from "./ExternalValues.vue?vue&type=template&id=36b74c08&scoped=true&"
import script from "./ExternalValues.vue?vue&type=script&lang=js&"
export * from "./ExternalValues.vue?vue&type=script&lang=js&"
import style0 from "./ExternalValues.vue?vue&type=style&index=0&id=36b74c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b74c08",
  null
  
)

export default component.exports